import styled from 'styled-components';
import Loader from './Loader';


export default function LoaderPage() {
  return (
    <Content>
      <Loader color="#3498db" />
    </Content>
  );
}


const Content = styled.div`
  width: 100%;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;